import React from "react";
import { CalendarDays, TriangleAlert, X, Send, Loader2 } from "lucide-react";
import TailwindModal from "./TailwindModal";
const SubmitDsrConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isLoading,
}) => {
  return (
    <TailwindModal
      isOpen={isOpen}
      toggle={!isLoading ? onClose : undefined}
      maxWidth="md"
    >
      <div className="p-0">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-orange-50 text-orange-600">
              <CalendarDays size={18} />
            </div>

            <div>
              <h2 className="m-0 text-[16px] font-semibold text-slate-900">
                {title}
              </h2>

              <p className="m-0 mt-0.5 text-[12px] text-slate-500">
                Daily status submission
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
          >
            <X size={17} />
          </button>
        </div>

        {/* Content */}
        <div className="px-5 py-4">
          <div className="flex items-start gap-3 rounded-xl border border-orange-100 bg-orange-50/70 p-3.5">
            <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-orange-100 text-orange-600">
              <TriangleAlert size={15} />
            </div>

            <p className="m-0 text-[13px] font-medium leading-5 text-orange-900">
              {message}
            </p>
          </div>

          <p className="m-0 mt-3 text-[12px] leading-[18px] text-slate-500">
            Please confirm if this was intentional or if you meant to select a
            different date for your reporting.
          </p>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-2.5 border-t border-slate-100 bg-slate-50/70 px-5 py-3.5">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="flex h-9 items-center justify-center rounded-lg border border-slate-200 bg-white px-4 text-[12px] font-semibold text-slate-700 transition hover:bg-slate-50 disabled:opacity-50"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="flex h-9 min-w-[140px] items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 text-[12px] font-semibold text-white shadow-sm shadow-blue-600/20 transition hover:bg-blue-700 disabled:opacity-70"
          >
            {isLoading ? (
              <>
                <Loader2 size={15} className="animate-spin" />
                Submitting...
              </>
            ) : (
              <>
                <Send size={15} />
                Continue Submit
              </>
            )}
          </button>
        </div>
      </div>
    </TailwindModal>
  );
};

export default SubmitDsrConfirmDialog;
